import React from 'react';
interface CornerOrnamentProps {
  className?: string;
}
export function CornerOrnament({
  className = ''
}: CornerOrnamentProps) {
  return <svg viewBox="0 0 56 56" fill="none" stroke="currentColor" strokeWidth="1" className={className} aria-hidden="true" data-id="element-26" data-mp="3epdqzdzpyqwg">
      <path d="M2 54 V2 H54" data-id="element-27" data-mp="3jmdxtr4e7xom" />
      <path d="M8 46 V8 H46" data-id="element-28" data-mp="3ofgrs0d3195c" />
      <path d="M8 8 C 18 8, 24 14, 24 24 C 14 24, 8 18, 8 8 Z" fill="currentColor" fillOpacity="0.18" data-id="element-29" data-mp="3ogi6qfx7yfsc" />
      <path d="M24 24 C 30 30, 38 30, 44 26" data-id="element-30" data-mp="3tdib8mef7ahc" />
      <path d="M24 24 C 30 30, 30 38, 26 44" data-id="element-31" data-mp="27gzscqjmev6" />
      <circle cx="44" cy="26" r="1.6" fill="currentColor" data-id="element-32" data-mp="265u27djex1f" />
      <circle cx="26" cy="44" r="1.6" fill="currentColor" data-id="element-33" data-mp="68ssir4prg7l" />
      <path d="M2 2 L8 8" data-id="element-34" data-mp="677uusn3rh5i" />
    </svg>;
}